import request from '@/common/request'

export default {
  /**
   *  create 增
   *  delete 删
   *  update 改
   *  query  查
   */
  //  1、发行信息验证
  infoVerification: data => {
    return request({
      url: '/publish/infoVerification',
      method: 'post',
      data,
    })
  },
  //  2、上传设备发行信息
  infoUpload: data => {
    return request({
      url: '/publish/infoUpload',
      method: 'post',
      data,
    })
  },
  //  3、上传设备发行确认信息
  infoDeviceConfirm: data => {
    return request({
      url: '/publish/infoDeviceConfirm',
      method: 'post',
      data,
    })
  },
  //  4、后台确认发行信息
  infoConfirm: data => {
    return request({
      url: '/publish/infoConfirm',
      method: 'post',
      data,
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/keyPublish.js